import { render } from "./StackedBarChart.vue?vue&type=template&id=7d792b9a&ts=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"symbiosy-vue-chatjs/src/components/StackedBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d792b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d792b9a', __exports__)) {
    api.reload('7d792b9a', __exports__)
  }
  
  module.hot.accept("./StackedBarChart.vue?vue&type=template&id=7d792b9a&ts=true", () => {
    api.rerender('7d792b9a', render)
  })

}


export default __exports__